import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70f78aa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#f90","font-size":"15px","margin-top":"30px","margin-left":"5%","margin-right":"5%"} }, " （注意：请确认您所输入的姓名、身份证号准确无误，将影响到您的预约事宜!） ", -1))
const _hoisted_3 = { style: {"margin":"38px","margin-top":"88px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("加载中...")

import { Dialog, Toast } from 'vant';
import { Ref, ref, onMounted, watch } from 'vue';
import Api from '@/http/api/index'
import { useRouter } from "vue-router";

interface MemberEntity {
    idNumber: string,
    phone: string,
    realName: string
}

enum StatusMsg {
    START_CERTIFICATION = '开始认证',
    NEXT_MSG = '下一步'
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const TAG = "taxUserIDConfirm";
//test:::/taxUserIDConfirm?memberId=ae8c2cf755ac5a03
const router = useRouter();
const confirmBtnMsg: Ref<string> = ref(StatusMsg.START_CERTIFICATION);

const loading = ref(false);
const onRefresh = () => {
    loadData(() => {
        setTimeout(() => {
            loading.value = false;
        }, 500);
    })
};
let memberId: string = '';
const vantLoadingStatus: Ref<boolean> = ref(false)
const hasConfirmed: Ref<boolean> = ref(false)
const submitBtnVisible: Ref<boolean> = ref(false)

const currentMemberInfo: Ref<MemberEntity> = ref({
    idNumber: '',
    phone: '',
    realName: ''
});

let orginalName: string = '';
let orginalIdNumber: string = '';
watch(currentMemberInfo, (value) => {
    if (hasChangedData()) {
        confirmBtnMsg.value = StatusMsg.START_CERTIFICATION
    } else {
        confirmBtnMsg.value = StatusMsg.NEXT_MSG
    }
}, {
    deep: true
})

onMounted(() => {
    loadData()
});

const loadData = (success?: () => void, fail?: () => void) => {
    let currentMemberID = router.currentRoute.value.query.memberId
    if (currentMemberID) {
        memberId = '' + currentMemberID
        getRealNameByMemberId(memberId, (value) => {
            success && success();
            currentMemberInfo.value = value
            if (currentMemberInfo.value.idNumber && currentMemberInfo.value.phone && currentMemberInfo.value.realName) {
                hasConfirmed.value = true
                confirmBtnMsg.value = StatusMsg.NEXT_MSG
                orginalName = currentMemberInfo.value.realName
                orginalIdNumber = currentMemberInfo.value.idNumber
            } else {
                hasConfirmed.value = false
                confirmBtnMsg.value = StatusMsg.START_CERTIFICATION
                // setTimeout(() => {
                //     showTipsDialog();
                // }, 300)
            }
            submitBtnVisible.value = true
        }, (value: any) => {
            fail && fail();
        })
    } else {
        success && success();
        submitBtnVisible.value = true
        showTipsDialog();
    }
}
const showTipsDialog = (confirm?: () => void) => {
    Dialog.confirm({
        message: "<span  style='color:#f60;font-size:18px;line-height:30px;'>请确认您所输入的姓名、身份证号准确无误，将影响到您的预约事宜!</span>",
        allowHtml: true,
        messageAlign: 'left',
        confirmButtonText: '确认',
        cancelButtonText: '再想想',
    }).then(() => {
        // on confirm
        confirm && confirm();
    }).catch(() => {
        // on cancel
    });
}

const onSubmit = (values: any) => {
    console.log('submit', values);
    if (hasConfirmed.value) {
        if (hasChangedData()) {
            showTipsDialog(() => {
                postAuth(() => {
                    navigateToNextPage();
                });
            })

        } else {
            navigateToNextPage();
        }
    } else {
        showTipsDialog(() => {
            postAuth(() => {
                navigateToNextPage();
            });
        });
    }
};
const navigateToNextPage = () => {
    router.push({
        path: `/taxDepartmentSelection`,
        query: {
            memberId
        }
    })
}
const hasChangedData: () => boolean = () => {
    if (currentMemberInfo.value.realName == orginalName && currentMemberInfo.value.idNumber == orginalIdNumber) {
        return false;
    } else {
        return true;
    }
}
const postAuth = (success?: () => void, fail?: () => void) => {
    let paramData = {
        "memberId": memberId,
        "realName": currentMemberInfo.value.realName,
        "idNumber": currentMemberInfo.value.idNumber
    }
    vantLoadingStatus.value = true

    postRealNameAuth(paramData, (value) => {
        Toast.success('认证成功！');
        setTimeout(() => {
            vantLoadingStatus.value = false;
            setTimeout(() => {
                success && success();

            }, 600)
        }, 400)
    }, (value) => {
        setTimeout(() => {
            vantLoadingStatus.value = false;
            fail && fail();
        }, 400)
    })
}

const getRealNameByMemberId = (memberId: String, success: (value: MemberEntity) => void, fail: (value: any) => void) => {
    Api.getRealNameByMemberId({
        params: {
            "memberId": memberId
        },
        success: (res: any) => {
            console.log('success:', res);
            if (res.code == 0) {
                success(res.data as MemberEntity)
            } else {
                Toast('' + res.msg)
                fail('' + res.msg)
            }
        },
        fail: (value: any) => {
            Toast('' + value)
            fail('' + value)
        }
    })
}
const postRealNameAuth = (memberInfo: {
    memberId: string,
    realName: string,
    idNumber: string
}, success: (res: any) => void, fail: (value: any) => void) => {
    Api.postRealNameAuth({
        params: {
            "memberId": memberInfo.memberId,
            "realName": memberInfo.realName,
            "idNumber": memberInfo.idNumber
        },
        success: (res: any) => {
            console.log('success:', res);
            if (res.code == 0) {
                success('')
            } else {
                Toast.fail('' + res.msg);
                fail('' + res.msg)
            }
        },
        fail: (value: any) => {
            Toast.fail('' + value);
            fail('' + value)
        }
    })
}



return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      class: "pull-refresh",
      modelValue: loading.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((loading).value = $event)),
      "success-text": "刷新成功",
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_form, { onSubmit: onSubmit }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell_group, { inset: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  modelValue: currentMemberInfo.value.realName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentMemberInfo.value.realName) = $event)),
                  name: "userName",
                  label: "姓名",
                  placeholder: "请输入真实姓名",
                  rules: [{ required: true, message: '用户名不能为空' }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: currentMemberInfo.value.idNumber,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentMemberInfo.value.idNumber) = $event)),
                  name: "idCard",
                  label: "身份证",
                  placeholder: "请输入身份证号",
                  rules: [{ required: true, message: '身份证号不能为空' }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  name: "phoneNum",
                  label: "手机号",
                  readonly: "",
                  modelValue: currentMemberInfo.value.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentMemberInfo.value.phone) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_2,
            _withDirectives(_createElementVNode("div", _hoisted_3, [
              _createVNode(_component_van_button, {
                class: "custom-button",
                round: "",
                block: "",
                "native-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(confirmBtnMsg.value), 1)
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, submitBtnVisible.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_overlay, { show: vantLoadingStatus.value }, {
          default: _withCtx(() => [
            _createVNode(_component_van_loading, {
              type: "spinner",
              color: "#f5f5f5",
              size: "30"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})